<div id="error-container">
  <div id="error-page-container">
    <div class="shadow" id="error-form-container">
      <div class="triangle-logo">
        <img src="assets/images/A.svg" />
      </div>
      <div class="logo">
        <img src="assets/images/logo.svg" />
      </div>
      <div class="mt-4">
        <h1 class="title text-center fw-bold">{{ '448595' | apmTranslate }}</h1>
        <div class="text-center">{{ '448662' | apmTranslate }}</div>
      </div>
      <div class="w-100" id="button-wrapper">
        <apm-button routerLink="/">{{ '448596' | apmTranslate }}</apm-button>
      </div>
    </div>
  </div>
</div>
